import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true); setError("");
    try { const u: any = await login(email, password); nav(u?.role === "installer" ? "/my-jobs" : "/"); } catch (err) { setError(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="relative hidden bg-[#0b0d14] lg:block">
        <img src="/login-hero.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#06080f] via-transparent to-transparent" />
        <div className="absolute bottom-16 left-16 right-16 text-white">
          <div className="text-xs uppercase tracking-[0.35em] text-amber-400">Starlites Holiday Lighting</div>
        </div>
      </div>
      <div className="flex items-center justify-center bg-gray-50 p-8">
        <form onSubmit={submit} className="w-full max-w-sm rounded-lg border border-gray-200 bg-white p-8 shadow-sm fade-up" data-testid="login-form">
          <div className="mb-6 flex items-center gap-2.5">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-blue-700 text-white"><Sparkles size={18} /></div>
            <div><div className="text-base font-bold text-gray-900">StarLites BusOps</div><div className="text-xs text-gray-500">Sign in to your workspace</div></div>
          </div>
          <div className="space-y-4">
            <div><Label htmlFor="email">Email</Label><Input id="email" data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" /></div>
            <div><Label htmlFor="password">Password</Label><Input id="password" data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1" /></div>
            {error && <div className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="login-error">{error}</div>}
            <Button type="submit" data-testid="login-submit-btn" className="w-full bg-blue-700 hover:bg-blue-800" disabled={loading}>{loading ? "Signing in…" : "Sign in"}</Button>
          </div>
        </form>
      </div>
    </div>
  );
}
